import styled from 'styled-components';
import { CredusText, color } from 'ui';

import { Loader } from '../../assets/images/svgs';

interface ComponentLoaderProps {
  loaderText?: string;
}

const ComponentLoader = ({ loaderText }: ComponentLoaderProps) => {
  return (
    <Container>
      <div>
        <Loader />
        <CredusText weight="regular" size="lg">
          {loaderText}
        </CredusText>
      </div>
    </Container>
  );
};

export default ComponentLoader;

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background: ${color.white};
  width: 100%;
  height: 100%;
`;
